import React from 'react';
import DonationCounter from './DonationCounter';

export default class extends React.PureComponent {

  render() {
    const { donated, donationGoal, progress, endsAt, furtherSupportUrl, organizationName } = this.props;

    const endedAtDate = new Date(Date.parse(endsAt));
    const campaignEndsOnFormattedDate = endedAtDate.getDate() + '. ' + (endedAtDate.getMonth() + 1) + '. ' + endedAtDate.getFullYear();

    return (
      <div className="c-floating">
        <section className="donation">
          <div className="c-floating__body">
            <DonationCounter donated={donated} goal={donationGoal} progress={progress} />

            <div className="estimation">
              <div className="donation__cfloating-padding donation__text-disabled">
              Táto darovacia výzva pre organizáciu {organizationName} sa skončila {campaignEndsOnFormattedDate}.
              <br />
              <strong>Chcete nás stále podporiť?</strong> <a href={furtherSupportUrl} className="u-underline">Pozrite si naše aktivity na našej stránke</a>.
              </div>
            </div>

            <div className="donation__cfloating-padding">
              <a href={furtherSupportUrl} className="c-button c-button--primary donation__submit">
                <span className="c-button__content">
                  <span className="text-icon">
                    <span className="text-icon__text">Podporte nás</span>
                    <i className="icon-arrow-forward text-icon__icon" />
                  </span>
                </span>
              </a>
            </div>
          </div>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/donation/InactiveDonation.js